/*
 * Copyright (c) 2019. Nedaware SL
 */

import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {BaseDialogData} from "../../basic-entity-front/basic-entity-table/base-dialog-data";
import {UntypedFormBuilder} from "@angular/forms";
import {Zona} from "../../model/localizacion/zona.model";
import {Pais} from "../../model/localizacion/pais.model";
import {Comunidad} from "../../model/localizacion/comunidad.model";
import {Provincia} from "../../model/localizacion/provincia.model";
import {Municipio} from "../../model/localizacion/municipio.model";
import {InterfaceProviderService} from "../../basic-entity-back/services/interface-provider.service";
import {EntityNameService} from "../../basic-entity-back/services/entity-name.service";
import {EditionListDialogComponent} from "./edition-list-dialog.component";
import {SimpleDialogService} from "../../basic-entity-front/dialog-shell/simple-dialog.service";
import {ErrorDisplayService} from "../../basic-entity-front/services/error-display.service";
import {ApiModuleFactory} from "../../api/api-module-factory.service";

@Component({
    selector: 'app-zona-edition',
    templateUrl: './edition-list-dialog.component.html',
    styleUrls: ['./edition-list-dialog.component.scss']
})
export class ZonaEditionComponent extends EditionListDialogComponent<Zona> {
    constructor(
        @Inject(MAT_DIALOG_DATA) data: BaseDialogData<Zona>,
        dialogRef: MatDialogRef<ZonaEditionComponent>,
        apiService: ApiModuleFactory,
        fb: UntypedFormBuilder,
        nameProvider: EntityNameService,
        interfaceProvider: InterfaceProviderService,
        confirmationDialog: SimpleDialogService,
        errorDisplay: ErrorDisplayService
    ) {
        super(
            'zonas',
            [
                {name: 'Países', property: 'zona', model: Pais},
                {name: 'Comunidades', property: 'zonaPropia', model: Comunidad},
                {name: 'Provincias', property: 'zonaPropia', model: Provincia},
                {name: 'Municipios', property: 'zonaPropia', model: Municipio}
            ],
            data, dialogRef, apiService, fb, nameProvider, confirmationDialog, interfaceProvider, errorDisplay);
    }
}
